import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App';
import {IconButton,Table,TableBody,TableCell,TableHead,TableRow,Button,TableContainer,Paper,Pagination,MenuItem,Select,FormControl,InputLabel,Box,TextField
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const PSG_vs_Billing_Group_Mapping = () => {
  const [billingData, setBillingData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [billingGroupOptions, setBillingGroupOptions] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
     const login_id = localStorage.getItem("LOGIN_ID");

  useEffect(() => {
    fetchBillingData();
    fetchBillingGroupOptions();
  }, []);

  const fetchBillingData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/getPSGBillingData`);
      const data = response.data || [];
      setBillingData(data);
      setOriginalData(JSON.parse(JSON.stringify(data)));
    } catch (error) {
      console.error('Error fetching billing data:', error);
      Swal.fire('Error', 'Failed to fetch billing data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchBillingGroupOptions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/getBillingGroupOptions`);
      setBillingGroupOptions(response.data || []);
    } catch (error) {
      console.error('Error fetching billing group options:', error);
    }
  };

  const handleEditClick = (index) => {
    setEditRow(index);
  };

  const handleDropdownChange = (index, newGroup) => {
    const updated = [...billingData];
    updated[index].billing_group = newGroup;
    setBillingData(updated);
    setEditRow(null);
  };

//   const handleUpdateAll = async () => {
//     const changedRows = billingData.filter((row, index) =>
//       row.billing_group !== originalData[index]?.billing_group
//     );

//     if (changedRows.length === 0) {
//       Swal.fire('Info', 'No changes to update.', 'info');
//       return;
//     }

//     try {
//       await axios.post(`${BASE_URL}/updateBillingGroups`, {
//         updatedGroups: changedRows,
//       });

//       Swal.fire('Success', 'Billing groups updated successfully', 'success');
//       const updatedOriginal = JSON.parse(JSON.stringify(billingData));
//       setOriginalData(updatedOriginal);
//     } catch (error) {
//       console.error('Update failed:', error);
//       Swal.fire('Error', 'Failed to update billing groups', 'error');
//     }
//   };
const handleUpdateAll = async () => {
  const changedRows = billingData
    .map((row, index) => {
      const original = originalData[index];
      if (row.billing_group !== original?.billing_group) {
        return {
          ...row,
          old_billing_group: original.billing_group,
        };
      }
      return null;
    })
    .filter(Boolean);

  if (changedRows.length === 0) {
    Swal.fire('Info', 'No changes to update.', 'info');
    return;
  }

  try {
    await axios.post(`${BASE_URL}/updateBillingGroups`, {
      updatedGroups: changedRows,
      login_id: login_id,
    });

    Swal.fire('Success', 'Billing groups updated successfully', 'success');
    setOriginalData(JSON.parse(JSON.stringify(billingData)));
  } catch (error) {
    console.error('Update failed:', error);
    Swal.fire('Error', 'Failed to update billing groups', 'error');
  }
};


  const handlePageSizeChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const filteredData = billingData.filter((item) =>
    item.psg.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirst, indexOfLast);

  return (
    <div style={{ padding: 20 }}>
      {/* <h2 style={{ fontWeight: 'bold', marginBottom: 16 }}>PSG vs Global Billing</h2> */}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {/* Search and Page Size */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <TextField
              size="small"
              label="Search by PSG"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1); 
              }}
            />
            <FormControl size="small">
              <InputLabel>Rows per page</InputLabel>
              <Select
                value={rowsPerPage}
                label="Rows per page"
                onChange={handlePageSizeChange}
              >
                {[5, 10, 15, 25, 50].map((val) => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 450,
              overflowY: 'auto',
              border: '1px solid #ccc',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: '	#90caf9', color: 'Black', fontWeight: 'bold' }}
                  >
                    PSG Code
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: '	#90caf9', color: 'Black', fontWeight: 'bold' }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: '	#90caf9', color: 'Black', fontWeight: 'bold' }}
                  >
                    Billing Group
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentRows.length > 0 ? (
                  currentRows.map((item, idx) => {
                    const globalIndex = billingData.findIndex(
                      (r) => r.psg === item.psg
                    );
                    const isChanged =
                      item.billing_group !== originalData[globalIndex]?.billing_group;

                    return (
                      <TableRow
                        key={globalIndex}
                        style={{ backgroundColor: isChanged ? '#d0f0c0' : 'white' }}
                      >
                        <TableCell>{item.psg}</TableCell>
                        <TableCell>{item.psg_desc}</TableCell>
                        <TableCell>
                          {editRow === globalIndex ? (
                            // <select
                            //   value={item.billing_group}
                            //   onChange={(e) =>
                            //     handleDropdownChange(globalIndex, e.target.value)
                            //   }
                            // >
                            //   <option value="">Select</option>
                            //   {billingGroupOptions.map((opt, i) => (
                            //     <option key={i} value={opt}>
                            //       {opt}
                            //     </option>
                            //   ))}
                            // </select>
                            <FormControl fullWidth size="small">
  <Select
    value={item.billing_group || ''}
    onChange={(e) => handleDropdownChange(globalIndex, e.target.value)}
    displayEmpty
  >
    <MenuItem value="">
      <em>Select</em>
    </MenuItem>
    {billingGroupOptions.map((opt, i) => (
      <MenuItem key={i} value={opt}>
        {opt}
      </MenuItem>
    ))}
  </Select>
</FormControl>

                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: 8 }}>{item.billing_group}</span>
                              <IconButton
                                size="small"
                                onClick={() => handleEditClick(globalIndex)}
                              >
                                <EditIcon style={{ color: 'orange' }} />
                              </IconButton>
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No data found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Pagination
              count={Math.ceil(filteredData.length / rowsPerPage)}
              page={currentPage}
              onChange={(e, page) => setCurrentPage(page)}
              color="primary"
            />
            <Button
              variant="contained"
              color="success"
              onClick={handleUpdateAll}
            >
              Update 
            </Button>
          </Box>
        </>
      )}
    </div>
  );
};

export default PSG_vs_Billing_Group_Mapping;
